import Filter, { PRODUCT_FILTER_META_FRAGMENT } from './Filter';
import Deck from './Deck';
import { AnimatePresence, motion } from 'framer-motion';
import ProductCard, { PRODUCT_CARD_FRAGMENT } from './ProductCard';
import Wrap from './Wrap';
import { gql } from '../util/fetchGql';
import NoProducts from './NoProducts';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import {
	prepareDestination
} from 'next/dist/shared/lib/router/utils/prepare-destination';

export const PRODUCTS_QUERY = gql`
	query (
		$brand: String
		$category: String
	) {
		products (orderBy: "defaultPrice desc") @filterProductsByEntryWithChildren (
			targetBrand: $brand
			targetProductCategory: $category
		) {
            ...ProductCard
            ...ProductFilterMeta
		}
	}
    ${PRODUCT_CARD_FRAGMENT}
    ${PRODUCT_FILTER_META_FRAGMENT}
`;

export default function Products ({
	products,
	filter,
	hideCategories = false,
	hideBrands = false,
}) {
	const [filteredProducts, setFilteredProducts] = useState(products);

	return (
		<Wrap grid>
			<Filter
				hideCategories={hideCategories}
				hideBrands={hideBrands}
				products={products}
				filterOptions={filter}
				setFilteredProducts={setFilteredProducts}
			/>
			<Deck inline>
				<AnimatePresence exitBeforeEnter>
					{filteredProducts?.map((product, i) => (
						<ProductCard
							{...product}
							key={product.key + '_' + i} /* Trick to remove the variant change anim when sorting */
							animation={{
								el: motion.a,
								initial: { opacity: 0 },
								animate: { opacity: 1 },
								exit: { opacity: 0 },
							}}
						/>
					))}
					{(filteredProducts?.length ?? 0) === 0 && (
						<NoProducts />
					)}
				</AnimatePresence>
			</Deck>
		</Wrap>
	);
}
